import {AxiosRequestConfig} from 'axios';


export const REACT_APP_BASE_API = 'https://dev-api.housecall.com.ph/api'; //dev
// export const REACT_APP_BASE_API = 'https://api.housecall.com.ph/api'; //prod
export const REACT_APP_BASE_WEB_URL = 'https://dev-web.housecall.com.ph/';
export const MERCHANT_CODE = 'PH01538'; // dev
// export const MERCHANT_CODE = 'PH01684';
export const RESPONSE_URL = 'https://dev-api.housecall.com.ph/api/payment/request';
export const BACKEND_URL = 'https://dev-api.housecall.com.ph/api/payment/callback';
export const IPAY88_PAYMENT_ENTRY_URL = 'https://sandbox.ipay88.com.ph/epayment/entry.asp';
export const MAJOR_VERSION = '1';
export const MINOR_VERSION = '5';
export const BUILD_NUMBER = '1297'; 
 
export const FCM_API_KEY = 'AIzaSyBXlNwACfBaF9KhcGkMk07qIJKG2M9FZxs';
export const FCM_AUTH_DOMAIN = 'house-call-3b5b3.firebaseapp.com';
export const FCM_PROJECT_ID = 'house-call-3b5b3';
export const FCM_STORAGE_BUCKET = 'house-call-3b5b3.firebasestorage.app';
export const FCM_MESSAGING_SENDER_ID = '744421065411';
export const FCM_APP_ID = '1:744421065411:web:007fc4eb07d2c441c0d876';
export const FCM_MEASUREMENT_ID = 'G-D3DY041TFN';
export const FCM_WEB_VAPID_KEY = 'BDAZKDMrOKlHU2wKDpMGmEun2AE523ujzGvcdYXXckLxEYGHvMQYzqCsi-k_aW19qjLc0SXUT2E3rfM9Nskq7XE';

export const AGORA_APP_ID = '6a66374b48854ec7bc24ba60595af045';

export const apiConfig: AxiosRequestConfig = {
  withCredentials: false,
  baseURL: REACT_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
  },
};